// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._modelList_lu5ki_1 {
  height: 100%;
  width: 100%;
  --perxis-auto-collapse-padding: var(--perxis-auto-gap-vertical-sky-inner) 0;
  --perxis-auto-collapse-panel-padding: var(--perxis-auto-gap-vertical-sky-inner) 0;
  --perxis-auto-collapse-background-color: transparent;
  --perxis-auto-collapse-divider-color: transparent;
}
._modelList_lu5ki_1 ._modelList__checkbox--loading_lu5ki_9.perxis-auto-1_18_1-model-checkbox-group {
  width: 100%;
}
@media (min-width: 0px) and (max-width: 479px) {
  ._modelList_lu5ki_1 ._modelList__checkbox--loading_lu5ki_9.perxis-auto-1_18_1-model-checkbox-group > .perxis-auto-1_18_1-row > .perxis-auto-1_18_1-col:not(:nth-child(-n+4)) {
    display: none;
  }
}
@media (min-width: 576px) and (max-width: 1199px) {
  ._modelList_lu5ki_1 ._modelList__checkbox--loading_lu5ki_9.perxis-auto-1_18_1-model-checkbox-group > .perxis-auto-1_18_1-row > .perxis-auto-1_18_1-col:not(:nth-child(-n+2)) {
    display: none;
  }
}
@media (min-width: 1200px) {
  ._modelList_lu5ki_1 ._modelList__checkbox--loading_lu5ki_9.perxis-auto-1_18_1-model-checkbox-group > .perxis-auto-1_18_1-row > .perxis-auto-1_18_1-col:not(:nth-child(-n+4)) {
    display: none;
  }
}
._modelList_lu5ki_1 ._modelList__title_lu5ki_27 {
  /* Typography */
  --pa-model-list-title-font-family-inner: var(
    --pa-model-list-title-font-family,
    var(--perxis-auto-root-typography-h2-font-family-inner)
  );
  --pa-model-list-title-font-size-xxs-sm-inner: var(
    --pa-model-list-title-font-size-xxs-sm,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --pa-model-list-title-font-size-md-xxl-inner: var(
    --pa-model-list-title-font-size-md-xxl,
    var(--perxis-auto-root-typography-h2-font-size-xxl-inner)
  );
  --pa-model-list-title-font-weight-inner: var(
    --pa-model-list-title-font-weight,
    var(--perxis-auto-root-typography-h2-font-weight-inner)
  );
  --pa-model-list-title-letter-spacing-inner: var(
    --pa-model-list-title-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --pa-model-list-title-line-height-xxs-sm-inner: var(
    --pa-model-list-title-line-height-xxs-sm,
    var(--perxis-auto-root-typography-h3-line-height-xxl-inner)
  );
  --pa-model-list-title-line-height-md-xxl-inner: var(
    --pa-model-list-title-line-height-md-xxl,
    var(--perxis-auto-root-typography-h2-line-height-xxl-inner)
  );
  --pa-model-list-title-text-transform-inner: var(
    --pa-model-list-title-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --pa-model-list-title-color-inner: var(
    --pa-model-list-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-typography-h2-font-family: var(--pa-model-list-title-font-family-inner);
  --perxis-auto-typography-h2-font-weight: var(--pa-model-list-title-font-weight-inner);
  --perxis-auto-typography-h2-letter-spacing: var(--pa-model-list-title-letter-spacing-inner);
  --perxis-auto-typography-h2-text-transform: var(--pa-model-list-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--pa-model-list-title-color-inner);
  --perxis-auto-typography-h2-font-size-xxs: var(--pa-model-list-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h2-font-size-xs: var(--pa-model-list-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h2-font-size-sm: var(--pa-model-list-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h2-font-size-md: var(--pa-model-list-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h2-font-size-lg: var(--pa-model-list-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h2-font-size-xl: var(--pa-model-list-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h2-font-size-xxl: var(--pa-model-list-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h2-line-height-xxs: var(--pa-model-list-title-line-height-xxs-sm-inner);
  --perxis-auto-typography-h2-line-height-xs: var(--pa-model-list-title-line-height-xxs-sm-inner);
  --perxis-auto-typography-h2-line-height-sm: var(--pa-model-list-title-line-height-xxs-sm-inner);
  --perxis-auto-typography-h2-line-height-md: var(--pa-model-list-title-line-height-md-xxl-inner);
  --perxis-auto-typography-h2-line-height-lg: var(--pa-model-list-title-line-height-md-xxl-inner);
  --perxis-auto-typography-h2-line-height-xl: var(--pa-model-list-title-line-height-md-xxl-inner);
  --perxis-auto-typography-h2-line-height-xxl: var(--pa-model-list-title-line-height-md-xxl-inner);
  text-align: center;
  margin-top: calc(var(--perxis-auto-gap-vertical-yellow-inner) - var(--perxis-auto-gap-vertical-sky-inner));
}
._modelList_lu5ki_1 ._modelList__brandHeader_lu5ki_88 {
  display: flex;
  align-items: center;
  gap: var(--perxis-auto-gap-vertical-purple-inner) 24px;
}
._modelList_lu5ki_1 ._modelList__brandHeader_lu5ki_88 img {
  max-height: 40px;
  max-width: 50%;
}
._modelList_lu5ki_1 ._modelList__brandTitle_lu5ki_97 {
  --pa-model-list-brand-title-font-family-inner: var(
    --pa-model-list-brand-title-font-family,
    var(--perxis-auto-root-typography-h3-font-family-inner)
  );
  --pa-model-list-brand-title-font-size-xxs-sm-inner: var(
    --pa-model-list-brand-title-font-size-xxs-sm,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-model-list-brand-title-font-size-md-xxl-inner: var(
    --pa-model-list-brand-title-font-size-md-xxl,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --pa-model-list-brand-title-line-height-inner: var(
    --pa-model-list-brand-title-line-height,
    var(--perxis-auto-root-typography-h3-line-height-xxl-inner)
  );
  --pa-model-list-brand-title-font-weight-inner: var(
    --pa-model-list-brand-title-font-weight,
    var(--perxis-auto-root-typography-h3-font-weight-inner)
  );
  --pa-model-list-brand-title-letter-spacing-inner: var(
    --pa-model-list-brand-title-letter-spacing,
    var(--perxis-auto-root-typography-h3-letter-spacing-inner)
  );
  --pa-model-list-brand-title-text-transform-inner: var(
    --pa-model-list-brand-title-text-transform,
    var(--perxis-auto-root-typography-h3-text-transform-inner)
  );
  --pa-model-list-brand-title-color-inner: var(
    --pa-model-list-brand-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-typography-h3-font-family: var(--pa-model-list-brand-title-font-family-inner);
  --perxis-auto-typography-h3-font-weight: var(--pa-model-list-brand-title-font-weight-inner);
  --perxis-auto-typography-h3-letter-spacing: var(--pa-model-list-brand-title-letter-spacing-inner);
  --perxis-auto-typography-h3-text-transform: var(--pa-model-list-brand-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--pa-model-list-brand-title-color-inner);
  --perxis-auto-typography-h3-font-size-xxs: var(--pa-model-list-brand-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h3-font-size-xs: var(--pa-model-list-brand-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h3-font-size-sm: var(--pa-model-list-brand-title-font-size-xxs-sm-inner);
  --perxis-auto-typography-h3-font-size-md: var(--pa-model-list-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h3-font-size-lg: var(--pa-model-list-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h3-font-size-xl: var(--pa-model-list-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h3-font-size-xxl: var(--pa-model-list-brand-title-font-size-md-xxl-inner);
  --perxis-auto-typography-h3-line-height-xxs: var(--pa-model-list-brand-title-line-height-inner);
  --perxis-auto-typography-h3-line-height-xs: var(--pa-model-list-brand-title-line-height-inner);
  --perxis-auto-typography-h3-line-height-sm: var(--pa-model-list-brand-title-line-height-inner);
  --perxis-auto-typography-h3-line-height-md: var(--pa-model-list-brand-title-line-height-inner);
  --perxis-auto-typography-h3-line-height-lg: var(--pa-model-list-brand-title-line-height-inner);
  --perxis-auto-typography-h3-line-height-xl: var(--pa-model-list-brand-title-line-height-inner);
  --perxis-auto-typography-h3-line-height-xxl: var(--pa-model-list-brand-title-line-height-inner);
}
._modelList_lu5ki_1 ._modelList__brandDescription_lu5ki_150 {
  --pa-model-list-brand-description-font-family-inner: var(
    --pa-model-list-brand-description-font-family,
    var(--perxis-auto-root-typography-h3-font-family-inner)
  );
  --pa-model-list-brand-description-font-size-xxs-sm-inner: var(
    --pa-model-list-brand-description-font-size-xxs-sm,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --pa-model-list-brand-description-font-size-md-xxl-inner: var(
    --pa-model-list-brand-description-font-size-md-xxl,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --pa-model-list-brand-description-line-height-inner: var(
    --pa-model-list-brand-description-line-height,
    var(--perxis-auto-root-typography-h3-line-height-xxl-inner)
  );
  --pa-model-list-brand-description-font-weight-inner: var(
    --pa-model-list-brand-description-font-weight,
    var(--perxis-auto-root-typography-h3-font-weight-inner)
  );
  --pa-model-list-brand-description-letter-spacing-inner: var(
    --pa-model-list-brand-description-letter-spacing,
    var(--perxis-auto-root-typography-h3-letter-spacing-inner)
  );
  --pa-model-list-brand-description-text-transform-inner: var(
    --pa-model-list-brand-description-text-transform,
    var(--perxis-auto-root-typography-h3-text-transform-inner)
  );
  --pa-model-list-brand-description-color-inner: var(
    --pa-model-list-brand-description-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-typography-main-font-family: var(--pa-model-list-brand-description-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--pa-model-list-brand-description-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--pa-model-list-brand-description-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--pa-model-list-brand-description-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--pa-model-list-brand-description-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--pa-model-list-brand-description-font-size-xxs-sm-inner);
  --perxis-auto-typography-main-font-size-xs: var(--pa-model-list-brand-description-font-size-xxs-sm-inner);
  --perxis-auto-typography-main-font-size-sm: var(--pa-model-list-brand-description-font-size-xxs-sm-inner);
  --perxis-auto-typography-main-font-size-md: var(--pa-model-list-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-main-font-size-lg: var(--pa-model-list-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-main-font-size-xl: var(--pa-model-list-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--pa-model-list-brand-description-font-size-md-xxl-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--pa-model-list-brand-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--pa-model-list-brand-description-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--pa-model-list-brand-description-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--pa-model-list-brand-description-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--pa-model-list-brand-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--pa-model-list-brand-description-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--pa-model-list-brand-description-line-height-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
